import LazyLoad from 'vanilla-lazyload';

const initLazyLoad = () => {
  new LazyLoad({
    elements_selector: '.lazy',
  });
};

export { initLazyLoad };
